module.exports = __webpack_public_path__ + "static/media/bieres_01_full.46782f48.gif";